import React from 'react';
import SocialIconAtom from '@atoms/icon-atoms/social-icon-atoms';
import styled from '@emotion/styled/macro';
import { AAtom } from '@atoms/link-atoms/link-atoms';
import { GTM_ID } from '../../../../common/constants/gtmIds';
import { SocialLinkProps } from './social-links.types';

const SocialLink: React.FC<SocialLinkProps> = ({
  type,
  url,
  alt,
  width,
  height,
  fill,
  className,
}) => {
  return (
    <li className={className}>
      <AAtom href={url} data-gtm-id={GTM_ID.FOLLOW_US_LINK} target="_blank">
        <SocialIconAtom
          type={type}
          alt={alt}
          width={width}
          height={height}
          fill={fill}
        />
      </AAtom>
    </li>
  );
};

const StyledSocialLink = styled(SocialLink)``;

export default StyledSocialLink;
